import PropTypes from 'prop-types';
import React from 'react';

const LoadingSpin = ({ color = '#00adef', ...props }) => {
  const css = `
    .rotator {
        animation-name: spin;
        animation-duration: 800ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        transform-origin: 16px 16px;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    `;

  return (
    <svg width={32} height={32} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill={color} {...props}>
      <style type="text/css">{css}</style>
      <path opacity=".25" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4" />
      <path className="rotator" d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z" />
    </svg>
  );
};

LoadingSpin.propTypes = {
  color: PropTypes.string
};

export default LoadingSpin;
